import {
  SET_PRACTICES,
  SET_PRACTICES_QUERY_PARAMS,
  SET_PRACTICES_SET_IS_FETCHING,
} from '../constants/practicesActionsTypes';

const initialState = {
  list: [],
  params: {
    per_page: 10,
    page: 1,
    scope: ['withLocation', 'withTenant'],
    sort: 'created_at, desc',
    search: '',
  },
  isFetching: false,
  total: 0,
};

function practices(state = initialState, action) {
  switch (action.type) {
    case SET_PRACTICES:
      return {
        ...state,
        list: action.data.practices,
        total: action.data.total,
      };
    case SET_PRACTICES_QUERY_PARAMS:
      return {
        ...state,
        params: {
          ...state.params,
          ...action.params,
        },
      };
    case SET_PRACTICES_SET_IS_FETCHING:
      return {
        ...state,
        isFetching: action.isFetching,
      };
    default:
      return state;
  }
}

export default practices;
